import { Outlet, useLocation } from 'react-router';
import { useSession } from '@/auth/session';
import { accedeModule, moduleDuChemin } from '@/auth/modules';
import { AccesRefuse } from '@/pages/AccesRefuse';

/** Garde de route : une adresse d'un module non autorisé au profil affiche « Accès non autorisé » au lieu de la page. */
export function GardeModule() {
  const session = useSession();
  const { pathname } = useLocation();
  const module = moduleDuChemin(pathname);
  const profils = session?.utilisateur.profils ?? [];
  if (module && !accedeModule(profils, module)) return <AccesRefuse module={module} />;
  return <Outlet />;
}
